// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import SpisovaSluzbaApi from './../api/gen/spisovaSluzba/SpisovaSluzbaApi';
import StateSuggestField from "./StateSuggestField";

/**
 * Základní formátování názvu typu dokumentu.
 *
 * @param typDokument typ dokumentu
 */
function getNazev(typDokument : SpsTypDokument) {
    let result = typDokument.nazev;
    if (typDokument.kod) {
        result = typDokument.kod + " - " + typDokument.nazev;
    }
    return result;
}

/**
 * Field pro hledání typu dokumentů spisové služby.
 */
class SpsTypDokumentField extends AbstractReactComponent {
    getData = () => {
        return SpisovaSluzbaApi.findTypyDokumentu()
            .then(rows => rows.map(r => ({ ...r, _name: getNazev(r) })))
            .then(rows => {
                rows.sort((a, b) => a._name.localeCompare(b._name));
                return rows;
            });
    };

    handleOnChange = (value) => {
        const {onChange} = this.props;
        if (value) {
            const {_name, ...rest} = value;
            onChange(rest);
        } else {
            onChange(null);
        }
    };

    handleOnBlur = (value) => {
        const {onBlur} = this.props;
        if (value) {
            const {_name, ...rest} = value;
            onBlur(rest);
        } else {
            onBlur(null);
        }
    };

    render() {
        const {onChange, onBlur, ...other} = this.props;

        return <StateSuggestField
            getItemName={item => item ? (item._name || getNazev(item)) : ""}
            apiCall={this.getData}
            {...other}
            onChange={this.handleOnChange}
            onBlur={this.handleOnBlur}
        />
    }
}

export default SpsTypDokumentField;
